import Dexie from 'dexie';

class MyDatabase extends Dexie {
  constructor() {
    super('trendsSegmentDatabase');
    this.version(1).stores({});
    this.open().catch((err) => {
      console.error('Failed to open trendsSegmentDatabase database:', err);
    });
  }

  async createCustomerStore(customerId) {
    const customerStore = `${customerId?.replace('_', '')}_store`;
    const tableExists = this.tables.some((table) => table?.name === customerStore);

    if (!tableExists) {
      // Close the database before changing the schema
      await this.close();

      const currentVersion = this.verno;
      const newVersion = currentVersion + 1;

      // Increment the version and apply the new schema
      this.version(newVersion).stores({
        [customerStore]:
          '++id, intent, category, country, domain, sources, distinct_search_type, goals_concat, language, adgroup_name, campaign_name, campaign_type, keyword_city, keyword_state, keyword_country, page_city, page_state, page_country, market_share_segment, rank_bucket_segment',
      });

      // Reopen the database to apply the changes
      await this.open();
      console.log('New schema applied successfully for customer store:', customerStore);
    }

    return this.table(customerStore);
  }
}

const segmentDb = new MyDatabase();
export default segmentDb;
